"use strict";

exports.__esModule = true;
exports.useCookies = exports.cookiesDefault = exports.context = exports.CookiesProvider = exports.CookiesConsumer = exports.Agreed = void 0;
var React = _interopRequireWildcard(require("react"));
var _client = require("./client");
var _cookies = require("./cookies");
var _scripts = require("./scripts");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let Agreed = exports.Agreed = /*#__PURE__*/function (Agreed) {
  Agreed["TRUE"] = "true";
  Agreed["FALSE"] = "false";
  return Agreed;
}({});
const cookiesDefault = exports.cookiesDefault = {
  agreed: Agreed.FALSE,
  // Not to blink Cookie modals on initial mount
  settings: {
    analytics: false,
    marketing: false
  },
  onAgree: () => null,
  onChange: () => null
};
const context = exports.context = /*#__PURE__*/React.createContext(cookiesDefault);
const {
  Consumer: CookiesConsumer,
  Provider
} = context;
exports.CookiesConsumer = CookiesConsumer;
const CookiesProvider = _ref => {
  let {
    children,
    agreedInitial = cookiesDefault.agreed
  } = _ref;
  const [loaded, setLoaded] = React.useState(false);
  const [agreed, setAgreed] = React.useState(agreedInitial);
  const [settings, setSettings] = React.useState(cookiesDefault.settings);
  React.useEffect(() => {
    if (!loaded) {
      return;
    }
    if (agreed === Agreed.TRUE) {
      (0, _client.purge)(settings);
      (0, _scripts.loadScripts)(settings);
    } else {
      (0, _client.purge)(cookiesDefault.settings);
    }
  }, [loaded, agreed, settings]);
  React.useEffect(() => {
    setAgreed((0, _client.load)(_cookies.Cookie.AGREED));
    setLoaded(true);
    const val = (0, _client.load)(_cookies.Cookie.SETTINGS);
    if (val !== null) {
      const s = JSON.parse(val);
      setSettings(s);
    }
  }, []);
  const handleAgree = React.useCallback(agreed => {
    if (agreed) {
      (0, _client.save)(_cookies.Cookie.AGREED, Agreed.TRUE);
      setAgreed(Agreed.TRUE);
    } else {
      (0, _client.save)(_cookies.Cookie.AGREED, Agreed.FALSE);
      (0, _client.remove)(_cookies.Cookie.SETTINGS);
      setAgreed(Agreed.FALSE);
      setSettings(cookiesDefault.settings);
    }
  }, []);
  const handleChange = React.useCallback(val => {
    (0, _client.save)(_cookies.Cookie.SETTINGS, JSON.stringify(val));
    setSettings(val);
  }, []);
  return /*#__PURE__*/React.createElement(Provider, {
    value: {
      agreed,
      settings,
      onAgree: handleAgree,
      onChange: handleChange
    }
  }, children);
};
exports.CookiesProvider = CookiesProvider;
const useCookies = () => React.useContext(context);
exports.useCookies = useCookies;